export default __webpack_public_path__ + "static/media/photo--sm--tom.ab5cae45.jpg";